import select from "../../assets/selectarrow.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { transactionService } from "../../services/transaction.service";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import underscore from "underscore";
import up from "../../assets/icons/Caret_up.png";
import down from "../../assets/icons/Caret_down.png";
import { useRecoilValue } from "recoil";
import { transactionmasterDataAtom } from "../../store/transAtom";
import { vendorService } from "../../services/vendor.service";
import { useForm } from "react-hook-form";
import moment from "moment";
import LogicContext from "../../Context/LogicContext";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomDate, formatCustomDateWithoutTime } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";


function VendorPurchaseReceives(props) { 
  const [purchaseOrderList, setPurchaseOrderList] =  useState([]);
    const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  
    const { showToast } = useContext(LogicContext); 
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  

  useEffect(() => {
    vendorService.vendorPurchaseReceive(props.vendor_id).then(res => {
       const {purchase_receive_info} = res.data;
      
      if(purchase_receive_info?.length){
        setPurchaseOrderList(purchase_receive_info);
      }
   

    })
  }, [props.vendor_id]);


    // Memoized columns to prevent recreation
    const columns = useMemo(
      () => [
        {
          title: " Ref",
          key: "purchase_receive_ref_no",
          dataIndex: "purchase_receive_ref_no",
          className: "text-primary",
          sorter: (a, b) => (a?.purchase_receive_ref_no ?? "") - (b?.purchase_receive_ref_no ?? ""),
        },
            {
          title: "Date",
          dataIndex: "purchase_receive_date",
          sorter: (a, b) => (a?.purchase_receive_date ?? "").localeCompare(a?.purchase_receive_date ?? ""),
          render: (record) => <span> {formatCustomDateWithoutTime(record)} </span>,
        },
    
        {
          title: "Receive No",
          dataIndex: "purchase_receive_number",
          sorter: (a, b) => (a?.purchase_receive_number ?? "").localeCompare(a?.purchase_receive_number ?? ""),
  
        },
     
   
        {
          title: "Warehouse",
          dataIndex: "purchase_receive_warehouse_name",
          sorter: (a, b) => (a?.purchase_receive_warehouse_name ?? "").localeCompare(b?.purchase_receive_warehouse_name ?? ""),
        },
           {
          title: "Status",
          dataIndex: "purchase_receive_status_name",
          sorter: (a, b) => (a?.purchase_receive_status_name ?? "").localeCompare(b?.purchase_receive_status_name ?? ""),
        },
   
  
    
    
    
      ],
      []
    );
  






       const handleRowClick = (item) => {
      const  {purchase_receive_ref_no} =  item;
    const customerRoute = `/${currModuleId}/${currModuleName}/purchase-receives/details/${purchase_receive_ref_no}`;
    window.open(customerRoute, '_blank');

  }





  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await vendorService.getVendorPurchaseReceiveByDate({...formData, vendor_id: props.vendor_id});
      console.log('response ', response.data);
      const {purchase_receive_info} = response.data;
      if(purchase_receive_info?.length){
        setPurchaseOrderList(purchase_receive_info);
      }
   
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);


  
    return (  
        <>
          <div
          className="tab-pane border-2 p-3 fade show active"
          id="tabs-home"
          role="tabpanel"
          aria-labelledby="tabs-home-tab"
        >
         <section>
                <div className="flex flex-row items-end space-x-2">
                   <div>
                     <span className="ml-1 text-sm">From Date:</span>
                     <input
                       defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                       {...register("from_date")}
                       className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                       type="date"
                     />
                   </div>
                   <div>
                     <span className="ml-1 text-sm">To Date:</span>
                     <input
                       {...register("to_date")}
                       defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                       className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                       type="date"
                     />
                   </div>
                   <div>
                     <button
                       onClick={searchByDate}
                       type="button"
                       className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
                     >
                       Search
                     </button>
                   </div>
                 </div>
         
         <div className="flex  justify-between">
            

            
            </div>

            
             <section className="mt-5">
                    <GeneralCustomTable
                      tableHeadList={columns}
                      tableDataList={purchaseOrderList}
                      allowCheckBox={false}
                      setSelectedRows={()=> {}}
                      rowKey={(record) =>  {}}
                      handleRowClick={handleRowClick}
                    />
                  </section>

          </section>
          </div>
        </>
    );
}

export default VendorPurchaseReceives;